// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdCat_importCsvCard__+JzJE","addProdCatBtnContainer":"AddProdCat_addProdCatBtnContainer__sOWK4"};